<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='1'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">我的订单</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_ddgltop">
              <ul class="cght_ddglnavula">
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == null}" @click="changeState()">全部订单</a></li>
                <!-- <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.orderType == 2}">待付款 <em>1</em></a></li> -->
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == 0}" @click="changeState(0)">待发货<em></em></a></li>
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == 1}" @click="changeState(1)">待收货 <em></em></a></li>
              </ul>
              <div class="cght_ddglright">
                <!-- <div class="cght_ddglrightl"><a href="__ROOT__/Member/ddhsz">我的订单回收站</a></div>选中cght_ddglrightlxz -->
                <!-- <div class="cght_ddglrightr"><div><em><input type="text" class="cght_inputtextsh" ddkeywords/></em><a href="javascript:;" ddsearch></a></div></div> -->
              </div>
            </div>
            <div class="cght_table_boxhie" v-loading="qyloading">
              <div v-if="current_user.MAccountRole !== 3">
              <table class="cght_ddtable" v-for="(item, index) in list" :key="index" width="990" cellspacing="0" cellpadding="0">
                <tr class="cght_ddtabletb">
                  <td colspan="6">
                    <div class="cght_ddtablesj">{{item.create_time}}</div>
                    <div class="cght_ddtableddh">订单号：<em>{{item.order_id}}</em></div>
                    <div class="cght_ddtablesl" style="width: 103px;">数量</div>
                    <div class="cght_ddtablesl" style="width: 83px;">单价</div>
                    <div class="cght_ddtablesc" @click="delOrder(item.order_id)"><i class="iconfont cght_scddqdshowtc">&#xe611;</i></div>
                    <div class="cght_ddtablesc myprint" @click="deriveOrder(item)">导出</div>
                    <!-- <div class="cght_ddtablesc" v-if="item.pay_state==1" style="color:rgb(255, 68, 1);cursor:pointer;font-weight:bold;float:right;" @click="goToPay(item.order_id)">去付款</div> -->
                    <div class="cght_ddtablesl" style="width: 110px;">收货人</div>
                    <el-button v-if="item.pay_state==0" size="mini" type="danger" style="margin-top:5px;margin-left:130px;" plain @click="goToPay(item.order_id)">去支付</el-button>
                  </td>
                </tr>
                <tr v-for="(goods, i) in item.detail" :key="i">
                  <td width="465" class="cght_ddtablexxnrabox">
                    <div class="cght_ddtablexxnra">
                      <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}">
                        <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="60" height="60" />
                      </router-link>
                    </div>
                    <div class="cght_ddtablexxnrb">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank">{{goods.title}}</router-link></h3>
                    </div>
                    <div class="cght_ddtablexxnrc" style="width:95px;height: 62px;line-height: 62px;">x{{goods.number}}</div>
                    <!--<div class="cght_ddtablexxnrd"><a href="javascript:;">退货</a></div>-->
                  </td>
                  <td width="80" class="cght_ddtableshrm" v-if="goods.tax_price && goods.tax_price > 0"><div class="cght_ddtableje4">￥{{goods.tax_price}}</div></td>
                  <td rowspan="" width="80" class="cght_ddtableshrm" v-else><div class="cght_ddtableje4">询价</div></td>
                  <td rowspan="" width="106" class="cght_ddtableshrm">{{item.address_name}} <i class="iconfont cght_cght_scddqdshow">&#xe608;</i></td>
                  <td rowspan="" width="110">
                    <div class="cght_ddtableje5" v-if="goods.tax_price && goods.tax_price > 0">￥{{(goods.tax_price*goods.number).toFixed(2)}}</div>
                    <div class="cght_ddtableje5" v-else>询价</div>
                    <div class="cght_ddtableje4"><a>小计</a></div>
                  </td>
                  <td rowspan="" width="96">
                    <div class="cght_ddtablefkxxwc" v-if="item.pay_state==0">未支付</div>
                    <div class="cght_ddtablefkxxwc" v-if="item.pay_state==1">已支付</div>
                    <div class="cght_ddtablefkxxj">
                      <router-link :to="{path:'/OrderDetail',query:{order_id:item.order_id}}">订单详情</router-link>
                    </div>
                  </td>
                  <td rowspan="" width="100">
                    <div v-if="goods.state==0" class="cght_ddtablelast4">未发货</div>
                    <!-- <div v-if="goods.state==1" class="cght_ddtablelast6" style="color:#ff4401">已发货</div> -->
                    <div style="width:100%;display:block;height:50%;line-height:36px;color:#436aa6;cursor:pointer;text-align: center;">
                      <el-button v-if="goods.state==1" size="mini" type="primary" plain @click="takedeliveryofgoods(goods)">确认收货</el-button>
                    </div>
                    <div v-if="goods.state==1" class="cght_ddtablelast6" style="color:#dd662d;cursor: pointer;" @click="checkLogistics(goods,item)">查看物流</div>
                    <div v-if="goods.state==2" class="cght_ddtablelast4" style="color:#436aa6">已收货</div>
                  </td>
                </tr>
              </table>
              </div>
              <!-- 申购单 -->
              <div v-else>
              <table class="cght_ddtable" v-for="(item, index) in list" :key="index" width="990" cellspacing="0" cellpadding="0">
                <tr class="cght_ddtabletb">
                  <td colspan="6">
                    <div class="cght_ddtablesj">{{item.create_time}}</div>
                    <div class="cght_ddtableddh">订单号：<em>{{item.order_id}}</em></div>
                    <div class="cght_ddtablesl" style="width: 103px;">数量</div>
                    <div class="cght_ddtablesl" style="width: 170px;">价格</div>
                    <!-- <div class="cght_ddtablesc" @click="delPreOrder(item.order_id)"><i class="iconfont cght_scddqdshowtc">&#xe611;</i></div> -->
                    <div class="cght_ddtablesl" style="width: 270px;">规格</div>
                  </td>
                </tr>
                <tr v-for="(goods, i) in item.detail" :key="i">
                  <td width="465" class="cght_ddtablexxnrabox">
                    <div class="cght_ddtablexxnra">
                      <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}">
                        <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="60" height="60" />
                      </router-link>
                    </div>
                    <div class="cght_ddtablexxnrb">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank">{{goods.title}}</router-link></h3>
                    </div>
                    <div class="cght_ddtablexxnrc" style="width:90px;height: 60px;line-height: 60px;">x{{goods.number}}</div>
                    <!--<div class="cght_ddtablexxnrd"><a href="javascript:;">退货</a></div>-->
                  </td>
                  <td width="80" class="cght_ddtableshrm" v-if="goods.tax_price"><div class="cght_ddtableje4">￥{{goods.tax_price}}</div></td>
                  <td width="80" class="cght_ddtableshrm" v-else><div class="cght_ddtableje4">询价</div></td>
                  <td rowspan="" width="110">
                    <div class="cght_ddtableje5" v-if="goods.tax_price">￥{{(goods.tax_price*goods.number).toFixed(2)}}</div>
                    <div class="cght_ddtableje5" v-else>询价</div>
                    <div class="cght_ddtableje4"><a>小计</a></div>
                  </td>
                  <td colspan="2">
                    <el-tag size="mini" style="margin-left:10px;" v-for="(ie,i) in goods.specParamList" :key="i">{{ie.param_name}}：{{ie.option_value}}</el-tag>
                  </td>
                  <td rowspan="" width="80" class="cght_ddtableshrm">
                    <div v-if="goods.state==0" class="cght_ddtablelast4">未发货</div>
                    <div v-if="goods.state==1" class="cght_ddtablelast6" style="color:#ff4401">已发货</div>
                    <!-- <div v-if="goods.state==1" class="cght_ddtablelast6" style="color:#ff4401;cursor:pointer;">查看物流</div> -->
                    <div v-if="goods.state==2" class="cght_ddtablelast4" style="color:#436aa6">已收货</div>
                  </td>
                </tr>
              </table>
              </div>
              <div class="cght_meiyoudingdansc" v-if="emptyShow&&list.length==0">
                <div class="cght_meiyoudingdanscd">
                  <em>您还没有订单哦~</em>
                  <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link>
                </div>
              </div>
              <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
            </div>
          </div>
        </div>
      </div>
      <Logistics v-if="dialogFormVisible" :dialogFormVisible="dialogFormVisible" @changeParents="changeParents" :parents-list="parentsList"></Logistics>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/order'
import Logistics from '@/components/Logistics'

export default {
  name: 'MyOrder',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination, Logistics },
  data () {
    return {
      api,
      qyloading: false,
      listQuery: {
        limit: 10,
        order: 'create_time',
        filters: {
        }
      },
      downloadLoading: false,
      emptyShow: false,
      dialogFormVisible: false,
      parentsList: {}
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
    // 清除支付时存储的订单ID
    localStorage.removeItem('payOrder_id')
  },
  methods: {
    afterLoadData (list) {
      list.forEach(re => {
        re.detail.forEach(res => { if (res.specParamList) { res.specParamList = JSON.parse(res.specParamList) } if (res.leaveMessage) { res.leaveMessage = JSON.parse(res.leaveMessage) } })
      })
      this.emptyShow = true
      return list
    },
    changeState (state) {
      if (state === undefined) {
        this.listQuery.filters = {}
      } else {
        this.listQuery.filters = {state}
      }
      this.listQuery.page = 1
      this.LoadData()
    },
    delOrder (orderId) {
      this.$confirm('确定删除该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delOrder({orderId: orderId}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {})
    },
    deriveOrder (order) {
      this.$confirm('确定导出该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.downloadLoading) {
          return
        }
        var goods = order.detail
        goods.forEach(res => {
          if (res.specParamList && res.specParamList.length > 0) {
            let specParamList = []
            res.specParamList.map(res => {
              specParamList.push([res.param_name + ':' + res.option_value])
            })
            res.newparamList = specParamList.join(',')
          } else {
            res.newparamList = '-'
          }
          if (res.leaveMessage && res.leaveMessage.length > 0) {
            let leaveMessage = []
            res.leaveMessage.map(res => {
              leaveMessage.push([res.name + ':' + res.value])
            })
            res.newleaMessage = leaveMessage.join(',')
          } else {
            res.newleaMessage = '-'
          }
          if (res.tax_price === '0.00' || !res.tax_price) {
            res.tax_price = '询价'
            res.totalPrice = '询价'
          } else {
            res.totalPrice = (res.number * res.tax_price).toFixed(2)
          }
          if (!res.plant_sku) {
            res.plant_sku = res.sku
          }
        })
        this.downloadLoading = true
        import('@/vendor/Export2Excel').then(excel => {
          const title = ['', '', '志鹏供应链']
          const header = ['代码', '名称', '规格', '价格', '数量', '单位', '小计', '备注', '申购人']
          const filterVal = ['plant_sku', 'title', 'newparamList', 'tax_price', 'number', 'units', 'totalPrice', 'newleaMessage', 'premember_name']
          const merges = ['C1:F1', 'G1:H1'] // 合并单元格
          const list = goods
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excela({
            title,
            header,
            merges,
            data,
            filename: '志鹏供应链' + this.timeFormate(new Date()),
            autoWidth: true,
            bookType: 'xlsx'
          })
          this.downloadLoading = false
        })
      }).catch(() => {})
    },
    timeFormate (timeStamp) {
      let year = new Date(timeStamp).getFullYear()
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
      let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
      return year + '年' + month + '月' + date + '日'
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'title') {
          if (v[j]) {
            v[j].replace(/\n/g, '\r\n')
            return v[j].replace(/\n/g, String.valueOf('char(10)'))
          }
          return null
        }
        return v[j]
      }))
    },
    goToPay (orderId) {
      localStorage.setItem('payOrder_id', orderId)
      this.$router.push({path: '/ToPay'})
    },
    checkLogistics (item, order) {
      item.tel = order.tel
      this.parentsList = Object.assign({}, item)
      this.dialogFormVisible = true
    },
    changeParents (state) {
      this.dialogFormVisible = state
    },
    // 确认收货
    takedeliveryofgoods (goods) {
      this.$confirm('确认收到货了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.takedeliveryofgoods({ detailID: goods.detailID }).then(res => {
          goods.state = 2
          this.$message({
            type: 'success',
            message: '确认收货!'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
  .cght_meiyoudingdansc{
    display: block;
  }
  .myprint{
    color:#999999;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/my_order.vue